import * as Contentstack from 'contentstack';
const Stack = Contentstack.Stack(
    process.env.REACT_APP_API_KEY,
    process.env.REACT_APP_DELIVERY_TOKEN,
    process.env.REACT_APP_ENVIRONMENT
);

export const getHeaderContent = (store) => {
    let header = {
        header_status: 'INITIAL',
    };

    header.header_status = 'LOADING';
    store.setState({ header });
    try {
        //header query
        const headerQuery = Stack.ContentType('menu').Query();
        headerQuery
            .toJSON()
            .find()
            .then(
                function success(result) {
                    const headerData = result[0];
                    const isContentEmpty = headerData.length == 0;
                    header = isContentEmpty ? header : headerData[0];
                    header.header_status = isContentEmpty ? 'EMPTY' : 'SUCCESS';

                    store.setState({
                        header,
                    });
                },
                function error(err) {
                    const isError404 =
                        error.response && error.response.status === 404;
                    header.header_status = isError404 ? 'NOT_FOUND' : 'ERROR';

                    store.setState({ header });
                }
            );
    } catch (error) {
        store.setState({ status: 'ERROR`' });
    }
};
